import type { BillingProfile } from "./types";

type LogoProfile = Pick<BillingProfile, "id" | "logoPath">;

export function profileInitials(displayName: string): string {
  const words = displayName
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length === 0) return "II";
  return words
    .slice(0, 2)
    .map((word) => word[0]?.toLocaleUpperCase() ?? "")
    .join("");
}

export function isInlineProfileLogo(path: string): boolean {
  return path.startsWith("data:") || path.startsWith("blob:");
}

export async function resolveProfileLogoUrls(
  profiles: LogoProfile[],
  signStoragePath: (path: string) => Promise<string | null>,
): Promise<Record<string, string>> {
  const resolvedEntries = await Promise.all(
    profiles.map(async (profile): Promise<readonly [string, string] | null> => {
      const path = profile.logoPath.trim();
      if (!path) return null;
      if (isInlineProfileLogo(path)) return [profile.id, path] as const;
      const signedUrl = await signStoragePath(path);
      return signedUrl ? ([profile.id, signedUrl] as const) : null;
    }),
  );

  return Object.fromEntries(
    resolvedEntries.filter(
      (entry): entry is readonly [string, string] => entry !== null,
    ),
  );
}
